// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__zp-LB","spin":"Loader_spin__ezfVl","container":"Loader_container__LgcOV"};